import { Loader2, X } from 'lucide-react'
import { Button } from '@/shared/ui/primitives'

export type WaiverSignatureStepProps = {
  embedUrl: string
  sandbox: string
  templateName?: string
  isPolling: boolean
  onClose: () => void
}

export function WaiverSignatureStep({
  embedUrl,
  sandbox,
  templateName,
  isPolling,
  onClose,
}: WaiverSignatureStepProps) {
  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-background/95 backdrop-blur-sm">
      <div className="flex items-center justify-between border-b border-border px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground">
            {templateName ?? 'Liability Waiver'}
          </span>
          {isPolling ? (
            <span className="flex items-center gap-1 text-xs text-muted-foreground">
              <Loader2 className="size-3 animate-spin" aria-hidden />
              Waiting for completion
            </span>
          ) : null}
        </div>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onClose}
          aria-label="Close waiver signing"
        >
          <X className="size-4" />
        </Button>
      </div>
      <div className="relative flex-1">
        <iframe
          src={embedUrl}
          sandbox={sandbox}
          title="Liability waiver signing"
          className="h-full w-full border-0 bg-white"
        />
      </div>
    </div>
  )
}
